const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
});

const formatValue = (scaled, unit) => {
  const possibleScaled = scaled.toFixed(1);
  const hasRemainder = possibleScaled % 1 !== 0;
  const usedValue = hasRemainder ? possibleScaled : scaled.toFixed(0);
  return `$${usedValue}${unit}`;
};

export const actualCurrencyFormatter = (val) => {
  if (val >= 1_000_000) {
    return formatValue(val / 1_000_000, 'M');
  }
  if (val >= 1_000) {
    return formatValue(val / 1_000, 'K');
  }
  return currencyFormatter.format(val);
};

export const getMaxUnitValue = (maxValue) => {
  if (maxValue >= 1_000_000) {
    return 'M';
  }
  if (maxValue >= 1_000) {
    return 'K';
  }
  return '';
}

export const generateActualCurrencyFormatter = (units) => (val) => {

  if (units === 'M') {
    return formatValue(val / 1_000_000, 'M');
  }
  if (units === 'K') {
    return formatValue(val / 1_000, 'K');
  }
  return currencyFormatter.format(val);
};

export const getFormatterFromData = (data) => {
  const usedData = Object.values(data);
  const maxValue = usedData.reduce((max, val) => Math.max(max, val), 0);
  const maxUnits = getMaxUnitValue(maxValue);
  return generateActualCurrencyFormatter(maxUnits);
};
